import React, { useState } from "react";
import "./Navbar.css";
import {Link} from 'react-scroll'
import { Menu, Close } from "@material-ui/icons";
import { NavbarItems } from "../NavbarItems";
import Aux from '../../hoc/Aux'
import BottomSlidingPane from '../BottomSlidingPane/BottomSlidingPane'

const Navbar = () => {
  
  const [clicked,setClicked] = useState(false)
  const [open,setOpen] = useState(false)

  const handleClick = () => {
    setClicked(!clicked);
  };

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }


    return (
      <Aux>
        <nav className="navbar">
          <Link to="home" style={{ textDecoration: "none" }}>
            <img src={require('../../assets/swab_logo.png')} className="navbar-logo" style={{height:40}}/>
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            {!clicked ? (
              <Menu className="menu-icon" fontSize={"large"} />
            ) : (
              <Close className="menu-icon" fontSize={"large"} />
            )}
          </div>
          <ul className={clicked ? "nav-menu active" : "nav-menu"}>
            {NavbarItems.map((item, index) => {
              return (
                <li key={index}>
                  <a className={item.className} >
                    <Link
                    offset={-50}
                    spy={true}
                    smooth={true} 
                    duration={1000}
                    to={item.url}>
                    {item.title}
                    </Link>
                  </a>
                </li>
              );
            })}
          </ul>
          <Link
          offset={-50}
          spy={true}
          smooth={true} 
          duration={1000}
          to="contact-us"
          >
          <button className="navbar-button" >Contact us</button>
          </Link>
        </nav>
        <BottomSlidingPane handleOpen={open} handleClose={handleClose}/>
      </Aux>
    );
}

export default Navbar;
